import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../../../helpers/export'
import { getDefaultVsic } from '../../../../helper'
import InsuranceService from '../../core/InsuranceService'

export const postBusinessGrowth = createAsyncThunk(
  'companyAnalysis/industryAnalysis/insurance/businessGrowth',
  async (params, { rejectWithValue }) => {
    try {
      if (params?.isDynamicReport) {
        const {
          vsics,
          companyInfo = {},
          defaultIndustryId,
          compareIndustryId,
        } = params

        const defaultVsicId =
          defaultIndustryId || getDefaultVsic(vsics, companyInfo.mainVsicId).id

        const res = await InsuranceService.postBusinessGrowth({
          vsicDefault: defaultVsicId,
          vsicCompare: compareIndustryId,
          organizationId: companyInfo.organizationId,
        })

        return res.success
          ? { data: res.data, defaultVsicId }
          : rejectWithValue({ isLoading: false })
      } else {
        const { vsicDefault, ...others } = params
        const res = await InsuranceService.postBusinessGrowth({
          vsicDefault,
          ...others,
        })

        return res.success
          ? { data: res.data, defaultVsicId: vsicDefault }
          : rejectWithValue({ isLoading: false })
      }
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const downloadBusinessGrowth = createAsyncThunk(
  'companyAnalysis/industryAnalysis/insurance/businessGrowth/export',
  async (params) => {
    try {
      const res = await InsuranceService.downloadBusinessGrowth(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)
